module.exports = __webpack_public_path__ + "img/4-2.3694d68f.svg";